@if (data.node?.attrs.role !== 'title') {
  <div class="menu">
    <div class="flex flex-column">
      <div class="flex flex-row justify-center items-center">
        @if (data.type !== 'part') {
          <button
            class="flex-auto label"
            color="none"
            mat-button
            matTooltip="change {{data.node.type.name}} {{ data.node?.attrs.level }}"
            [matMenuTriggerFor]="headingMenu"
            matTooltipPosition="before"
          >
            @switch (data.node.type.name) {
              @case ('heading') {
                <b>
                  <mat-icon
                    aria-hidden="false"
                    [attr.aria-label]="'Heading level ' + data.node?.attrs.level"
                    [matBadge]="data.node?.attrs.level"
                    matBadgePosition="below"
                  >
                    short_text
                  </mat-icon>
                </b>
              }
              @case ('paragraph') {
                <b class="m1"><mat-icon>short_text</mat-icon></b>
              }
              @default {
                <b>
                  {{ data.node?.type?.name }}
                </b>
              }
            }
          </button>
        }
      </div>
    </div>
    <mat-menu #headingMenu="matMenu" yPosition="above">
      <button
        mat-menu-item
        [disabled]="data.node.type.name === 'paragraph'"
        (click)="setNodeType('paragraph')"
        [ngClass]="{ selected: data.node.type.name === 'paragraph' }"
      >
        <mat-icon>short_text</mat-icon>
        <span>Paragraph</span>
      </button>
      @for (heading of headings; track heading) {
        <button
          [disabled]="data.node.attrs.level === heading.level"
          mat-menu-item
          (click)="setHeadingLevel(heading.level)"
          class="button"
          [ngClass]="{ selected: (data.node.attrs.level === heading.level) }"
        >
          <small>{{ '#'.repeat(heading.level) }} </small><span>Heading {{heading.level}}</span>
        </button>
      }
    </mat-menu>
  </div>
}
